"use client";
import { DepictFilter } from "@/lib/hooks/useProductFilter/types";
/* import type { FormattedFilter, FormattedFilterGroup } from "@/lib/depict"; */
import { createContext, TransitionStartFunction, useMemo } from "react";

export type FormattedFilterGroup = any;
export type FormattedFilter = any;

export const FilterContext = createContext<{
  startTransition: TransitionStartFunction;
}>(null!);

export const useFormattedFilters = (
  filters: DepictFilter[],
): {
  formattedFilters: FormattedFilterGroup[];
} => {
  const formattedFilters = useMemo(() => {
    const filterGroups: FormattedFilterGroup[] = [];
    const sortOrder = ["color", "size", "category"];
    if (!filters) return filterGroups;

    for (const group of filters) {
      const formattedGroup: FormattedFilterGroup = {
        title: group.meta?.group_title,
        key: group.meta?.group_title?.toLocaleLowerCase(),
        label: group?.field,
        values: group?.meta?.values?.map((value, i) => {
          let hex: string | undefined;
          if (group.meta.group_title === "Color" && typeof value === "string") {
            hex = group?.meta.swatches[i];
          }

          return {
            value: value,
            hex,
            name: group.meta.names[i],
            count: group.meta.counts[i],
          };
        }) as FormattedFilter[],
      };

      filterGroups.push(formattedGroup);
    }

    filterGroups.sort((a, b) => {
      const indexA = sortOrder.indexOf(a.key);
      const indexB = sortOrder.indexOf(b.key);

      const orderA = indexA === -1 ? sortOrder.length : indexA;
      const orderB = indexB === -1 ? sortOrder.length : indexB;

      return orderA - orderB;
    });

    return filterGroups;
  }, [filters]);

  return {
    formattedFilters,
  };
};
